import React, { useState, useEffect, useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'
import { SelectionField } from '../common'
import { getSortedTimezones, getBrowserTimezone } from '../../utils/timezone'

const TimezoneModal = ({ show, setShowModal, onSave, isSaving }) => {
  const [selectedTimezone, setSelectedTimezone] = useState('')

  // Prepare timezone options - get all timezones from moment-timezone
  const timezoneOptions = useMemo(() => {
    return getSortedTimezones()
  }, [])

  // Get available timezone values as a Set for quick lookup
  const timezoneValues = useMemo(() => {
    return new Set(timezoneOptions.map((option) => option.value))
  }, [timezoneOptions])

  // Set default timezone when modal opens
  useEffect(() => {
    if (show) {
      const browserTimezone = getBrowserTimezone()
      if (browserTimezone && timezoneValues.has(browserTimezone)) {
        setSelectedTimezone(browserTimezone)
      } else {
        // If browser timezone not found, try to find a close match or set empty
        setSelectedTimezone('')
      }
    } else {
      // Reset when modal closes
      setSelectedTimezone('')
    }
  }, [show, timezoneValues])

  const handleSave = () => {
    if (selectedTimezone) {
      onSave(selectedTimezone)
    }
  }

  return (
    <Modal
      show={show}
      onHide={() => {
        setShowModal(false)
      }}
      size='md'
      centered
      backdrop='static'
      keyboard={false}
      className='payment-modal'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h5 className='payment-modal-title mb-0'>Select Time Zone</h5>
      </Modal.Header>
      <Modal.Body className='payment-modal-body p-3'>
        <div className='mb-3'>
          <label className='form-label'>Time Zone</label>
          <SelectionField
            options={timezoneOptions}
            getValueAsOption
            optionplaceholder='Select time zone'
            isUseFormikSelectionField={false}
            value={selectedTimezone}
            onChange={(event) =>
              setSelectedTimezone(event?.target?.value || '')
            }
            className='custom-timezone-select'
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex justify-content-end w-100'>
          <Button
            variant='none'
            className='confirmation-btn text-uppercase secondary-popup-button mr-2'
            size='sm'
            onClick={() => setShowModal(false)}
            disabled={isSaving}>
            Cancel
          </Button>
          <Button
            variant='saffron'
            className='confirmation-btn text-uppercase'
            size='sm'
            onClick={handleSave}
            isLoading={isSaving}
            disabled={!selectedTimezone || isSaving}>
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default TimezoneModal
